import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import camelCase from 'lodash/camelCase';

function state(params = {}) {
    return {
        isLoading: false,
        meta: {
            current_page: 1,
            last_page: null,
            page_size: 25,
            total: null,
            total_pages: 0
        },
        params: Object.assign({
            page: 1,
            page_size: 25,
            search: null,
            sort: null
        }, params),
        selected: [],
        tableData: []
    }
}

export default {
    namespaced: true,
    actions,
    state,
    mutations,
    getters
};
